import React from 'react';
const comparisonRows = [{
  situation: 'Tu precio',
  without: 'Lo mismo que cobra el del lugar de enfrente',
  with: 'Estructura de precios élite con 3 niveles'
}, {
  situation: 'Cuando alguien pregunta el precio',
  without: '"Son X por mes... ¿está bien?"',
  with: 'Script de cierre que convierte el 70%+'
}, {
  situation: 'Primera clase de un alumno nuevo',
  without: '"Ven a probar y ves cómo te va"',
  with: 'Sistema de Primera Victoria que fideliza'
}, {
  situation: 'Alumnos que se van sin avisar',
  without: 'Te enteras cuando ya se fueron',
  with: 'Semáforo Verde/Amarillo/Rojo con protocolo'
}, {
  situation: 'Marketing',
  without: 'Boca en boca y esperar',
  with: '4 canales activos + Google Maps optimizado'
}, {
  situation: 'Tu identidad',
  without: '"Soy profe de boxeo"',
  with: '"Soy dueño de un negocio de transformación"'
}, {
  situation: 'Ingresos',
  without: 'Variables e impredecibles',
  with: 'Sistema de membresías con ingresos estables'
}, {
  situation: 'Referidos',
  without: 'Los que llegan solos',
  with: 'Sistema estructurado que los multiplica'
}];
const modules = [{
  emoji: '💰',
  title: 'Módulo 1 — Estructura de Precios Élite',
  desc: 'Cobra lo que realmente vale tu trabajo'
}, {
  emoji: '🏆',
  title: 'Módulo 2 — Sistema de Membresías',
  desc: 'Base / Pro / VIP'
}, {
  emoji: '🧲',
  title: 'Módulo 3 — Imán de Alumnos Nuevos',
  desc: 'Captación que trabaja sola'
}, {
  emoji: '🎯',
  title: 'Módulo 4 — La Clase de Prueba que Convierte',
  desc: 'De 20% a 70%+'
}, {
  emoji: '📱',
  title: 'Módulo 5 — Marketing Local Pro',
  desc: 'Instagram + Google Maps + WhatsApp'
}, {
  emoji: '🔒',
  title: 'Módulo 6 — Retención de Acero',
  desc: 'Alumnos que se quedan 3 años'
}, {
  emoji: '🤝',
  title: 'Módulo 7 — Sistema de Referidos',
  desc: 'Cada alumno trae 2 más'
}, {
  emoji: '⚖️',
  title: 'Módulo 8 — Protección Legal',
  desc: 'Los 5 documentos esenciales'
}, {
  emoji: '📊',
  title: 'Módulo 9 — Calculadora de Rentabilidad',
  desc: 'Cuánto estás dejando'
}, {
  emoji: '🗓️',
  title: 'Módulo 10 — Plan de 90 Días',
  desc: 'Semana a semana para implementar todo'
}];
export function EliteSection() {
  return <section className="w-full bg-[#1a0f00] py-16 px-4" data-id="element-33">
      <div className="max-w-4xl mx-auto" data-id="element-34">
        <div className="text-center mb-10" data-id="element-35">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-36">
            🥊 ¿QUÉ AGREGA EL{' '}
            <span className="text-[#F97316]" data-id="element-37">MÉTODO GYM LLENO™</span>?
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-38">
            El sistema de negocio que hace que el gimnasio se llene y se
            mantenga lleno
          </p>
        </div>

        <div className="bg-black border border-[#F97316]/30 rounded-2xl overflow-hidden mb-12" data-id="element-39">
          <div className="grid grid-cols-1 sm:grid-cols-3 bg-[#0d0700] border-b border-[#F97316]/30" data-id="element-40">
            <div className="p-4 font-bold text-white hidden sm:block" data-id="element-41">
              Situación
            </div>
            <div className="p-4 font-bold text-gray-400 text-center border-l border-[#F97316]/30" data-id="element-42">
              Sin Método Gym Lleno
            </div>
            <div className="p-4 font-bold text-[#F97316] text-center border-l border-[#F97316]/30" data-id="element-43">
              Con Método Gym Lleno
            </div>
          </div>

          {comparisonRows.map((row, i) => <div key={i} className={`grid grid-cols-1 sm:grid-cols-3 ${i < comparisonRows.length - 1 ? 'border-b border-gray-800' : ''}`} data-id="element-44">
              <div className="p-4 text-white text-sm sm:text-base" data-id="element-45">
                <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-46">
                  Situación:
                </span>
                {row.situation}
              </div>
              <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-47">
                <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-48">
                  Sin Método Gym Lleno:
                </span>
                {row.without}
              </div>
              <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#F97316]/5" data-id="element-49">
                <span className="sm:hidden font-bold text-[#F97316] block mb-1" data-id="element-50">
                  Con Método Gym Lleno:
                </span>
                {row.with}
              </div>
            </div>)}
        </div>

        <h3 className="text-2xl font-black text-white text-center mb-8" data-id="element-51">
          ✅ MÉTODO GYM LLENO™ INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-52">
          {modules.map((mod, i) => <div key={i} className="bg-black border border-[#F97316]/20 rounded-xl p-5" data-id="element-53">
              <h4 className="text-[#F97316] font-bold text-lg mb-2" data-id="element-54">
                {mod.emoji} {mod.title}
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-55">{mod.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}